export default __webpack_public_path__ + "static/media/mk.d335b1f7.svg";